import { useState } from 'react'
import clsx from 'clsx'
import dayjs from 'dayjs'

import { useAppNavbar } from '@/shared/hooks/use-app-navbar'
import { useModal } from '@/shared/hooks/use-modal'
import { formattedBalance } from '@/shared/lib/formatters'
import { BottomSheet, Button, Icon } from '@/shared/ui'

import { Transaction } from '@/features/transaction'

import { WithdrawalLoading } from './withdrawal-loading'

import styles from './withdrawal.module.scss'

type TTransaction = {
    amount_cents: number // сумма в копейках (целое число, отрицательное для списаний)
    balance_cents?: number // баланс после операции в копейках (необязательно)
    comment?: string // комментарий, например "С комиссией $service_name$"
    currency: string // валюта, например "RUB"
    description: string // описание операции, например "Доход с заказа"
    duration_minutes?: number // только если есть длительность в описании
    status: 'completed' | 'processing' // статус: завершена или в обработке
    timestamp: string // ISO 8601 UTC, например "2026-01-20T14:32:00Z"
}

export const Withdrawal = () => {
    // Настройки мобилки
    useAppNavbar('Сумма к выводу', null, null)
    // const navigate = useNavigate()
    const loading = false
    const taxoparkName = 'Драйви'
    const [balance, setBalance] = useState<string>('10000000')
    const [integerPart, decimalPart] = formattedBalance(balance)
    const [isNew, setIsNew] = useState<boolean>(true)
    const { isModalOpen, openModal, closeModal, closeHandlerReady } = useModal()
    const [taxopark, setTaxopark] = useState<number>(0)
    const transactions: TTransaction[] = [
        {
            timestamp: dayjs().subtract(0, 'day').toISOString(),
            description: 'Доход с заказа',
            duration_minutes: 239,
            amount_cents: 30_076,
            currency: 'RUB',
            balance_cents: 32_000,
            status: 'processing',
        },
        {
            timestamp: '2026-01-20T14:32:00Z',
            description: 'Доход с заказа',
            amount_cents: 21_076,
            currency: 'RUB',
            balance_cents: 32_000,
            status: 'completed',
        },
        {
            timestamp: '2026-01-20T14:32:00Z',
            description: 'Вывод средств',
            amount_cents: -1_300_000,
            currency: 'RUB',
            balance_cents: 1_322_076,
            status: 'processing',
            comment: 'С комиссией $service_name$',
        },
        {
            timestamp: '2025-10-13T12:12:00Z',
            description: 'Достижение цели',
            amount_cents: 500_000,
            currency: 'RUB',
            status: 'completed',
        },
        {
            timestamp: '2025-10-13T10:54:00Z',
            description: 'Доход с заказа',
            amount_cents: 21_076,
            currency: 'RUB',
            balance_cents: 32_000,
            status: 'completed',
        },
        {
            timestamp: '2026-01-20T14:32:00Z',
            description: 'Доход с заказа',
            duration_minutes: 239,
            amount_cents: 30_076,
            currency: 'RUB',
            balance_cents: 32_000,
            status: 'processing',
        },
        {
            timestamp: '2026-01-20T14:32:00Z',
            description: 'Доход с заказа',
            amount_cents: 21_076,
            currency: 'RUB',
            balance_cents: 32_000,
            status: 'completed',
        },
        {
            timestamp: '2026-01-20T14:32:00Z',
            description: 'Вывод средств',
            amount_cents: -1_300_000,
            currency: 'RUB',
            balance_cents: 1_322_076,
            status: 'processing',
            comment: 'С комиссией $service_name$',
        },
        {
            timestamp: '2025-10-13T12:12:00Z',
            description: 'Достижение цели',
            amount_cents: 500_000,
            currency: 'RUB',
            status: 'completed',
        },
        {
            timestamp: '2025-10-13T10:54:00Z',
            description: 'Доход с заказа',
            amount_cents: 21_076,
            currency: 'RUB',
            balance_cents: 32_000,
            status: 'completed',
        },
        {
            timestamp: '2026-01-20T14:32:00Z',
            description: 'Доход с заказа',
            duration_minutes: 239,
            amount_cents: 30_076,
            currency: 'RUB',
            balance_cents: 32_000,
            status: 'processing',
        },
        {
            timestamp: '2026-01-20T14:32:00Z',
            description: 'Доход с заказа',
            amount_cents: 21_076,
            currency: 'RUB',
            balance_cents: 32_000,
            status: 'completed',
        },
        {
            timestamp: '2026-01-20T14:32:00Z',
            description: 'Вывод средств',
            amount_cents: -1_300_000,
            currency: 'RUB',
            balance_cents: 1_322_076,
            status: 'processing',
            comment: 'С комиссией $service_name$',
        },
        {
            timestamp: '2025-10-13T12:12:00Z',
            description: 'Достижение цели',
            amount_cents: 500_000,
            currency: 'RUB',
            status: 'completed',
        },
        {
            timestamp: '2025-10-13T10:54:00Z',
            description: 'Доход с заказа',
            amount_cents: 21_076,
            currency: 'RUB',
            balance_cents: 32_000,
            status: 'completed',
        },
    ]

    return loading ?
            <WithdrawalLoading />
        :   <div className={styles['withdrawal']}>
                <>
                    <button
                        onClick={() => {
                            setIsNew(true)
                            setBalance('0')
                        }}
                    >
                        Пустой пример
                    </button>
                    <button
                        onClick={() => {
                            setIsNew(false)
                            setBalance('10000000')
                        }}
                    >
                        Пример с транзакциями
                    </button>
                </>
                <div className={styles['withdrawal-top']}>
                    <div className={styles['withdrawal-top-header']}>
                        <div className={styles['withdrawal-top-header__text']}>
                            {isNew ?
                                <span className={styles['withdrawal-top-header__text']}>Сумма</span>
                            :   <>
                                    На счёту в{' '}
                                    <span
                                        className={styles['withdrawal-top-header__taxopark-name']}
                                    >
                                        {taxoparkName}
                                    </span>
                                </>
                            }
                        </div>
                        <div className={styles['withdrawal-top-balance']}>
                            <span className={styles['withdrawal-top-balance__amount']}>
                                <span className={styles['withdrawal-top-balance__amount--integer']}>
                                    {integerPart}
                                </span>
                                <span className={styles['withdrawal-top-balance__amount--decimal']}>
                                    {decimalPart ? `,${decimalPart}` : ''}&nbsp;
                                </span>
                                <span>
                                    <span
                                        className={
                                            styles['withdrawal-top-balance__amount--currency']
                                        }
                                    >
                                        ₽
                                    </span>
                                </span>
                            </span>
                            {!isNew && (
                                <Button
                                    className={styles['withdrawal-top-balance__button']}
                                    size='small'
                                    variant='secondary'
                                    onClick={openModal}
                                >
                                    <Icon icon='edit' size={20} />
                                </Button>
                            )}
                        </div>
                    </div>
                    <div className={styles['withdrawal-top-buttons']}>
                        <Button
                            disabled={Number(balance) <= 0 || isNew}
                            size='small'
                            variant='primary'
                            onClick={() =>
                                window.open('https://www.youtube.com/watch?v=dQw4w9WgXcQ', '_blank')
                            }
                        >
                            Инструкция по выводу
                        </Button>
                    </div>
                </div>

                <div
                    className={clsx(
                        styles['withdrawal-bottom'],
                        isNew && styles['withdrawal-bottom--new'],
                    )}
                >
                    {isNew ?
                        <>
                            <div className={styles['example']}>
                                <span className={styles['example__date']}>время заказа</span>
                                <div className={styles['example-description']}>
                                    <span className={styles['example-description__text']}>
                                        Доход с заказа
                                    </span>
                                    <div className={styles['example-description__amount']}>
                                        Чистый доход ₽
                                    </div>
                                </div>
                                <div className={styles['example-description__balance']}>
                                    <span>До вычета</span>
                                    <span>Стоимость поездки ₽</span>
                                </div>
                            </div>
                            <span className={styles['withdrawal-bottom__instruction']}>
                                Выполните заказ с оплатой по карте,
                                <br />
                                чтобы вывести деньги
                            </span>
                            <Button
                                className={styles['withdrawal-bottom__button']}
                                size='medium'
                                variant='primary'
                            >
                                Взять заказ
                            </Button>
                        </>
                    :   <>
                            <div className={styles['transactions-lenta']}>
                                {transactions.map((transaction) => (
                                    <Transaction
                                        key={transaction.timestamp}
                                        transaction={transaction}
                                    />
                                ))}
                            </div>
                        </>
                    }
                </div>
                {isModalOpen && (
                    <BottomSheet
                        withoutHeader
                        closeHandlerReady={closeHandlerReady}
                        onClose={closeModal}
                    >
                        <div className={styles['choose-txpark']}>
                            <div className={styles['choose-txpark-item']}>
                                <div className={styles['txpark']}>
                                    <div className={styles['txpark__balance']}>
                                        <span className={styles['txpark__balance--integer']}>
                                            4 542
                                        </span>
                                        <span className={styles['txpark__balance--decimal']}>
                                            ,15
                                        </span>
                                        <span className={styles['txpark__balance--currency']}>
                                            {' '}
                                            ₽
                                        </span>
                                    </div>
                                    <div className={styles['txpark__name']}>
                                        <span className={styles['txpark__name--text']}>Драйв</span>
                                        {taxopark === 0 && (
                                            <div className={styles['txpark__name--check']}>
                                                <Icon
                                                    color='var(--extensions-background-deep-brand)'
                                                    icon='check'
                                                    size={12}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {taxopark !== 0 && (
                                    <Button
                                        className={styles['choose-txpark-item__button']}
                                        size='small'
                                        variant='secondary'
                                        onClick={() => setTaxopark(0)}
                                    >
                                        Выбрать
                                    </Button>
                                )}
                            </div>
                            <div className={styles['choose-txpark-item']}>
                                <div className={styles['txpark']}>
                                    <div className={styles['txpark__balance']}>
                                        <span className={styles['txpark__balance--integer']}>
                                            4 542
                                        </span>
                                        <span className={styles['txpark__balance--decimal']}>
                                            ,15
                                        </span>
                                        <span className={styles['txpark__balance--currency']}>
                                            {' '}
                                            ₽
                                        </span>
                                    </div>
                                    <div className={styles['txpark__name']}>
                                        <span className={styles['txpark__name--text']}>Драйв</span>
                                        {taxopark === 1 && (
                                            <div className={styles['txpark__name--check']}>
                                                <Icon
                                                    color='var(--extensions-background-deep-brand)'
                                                    icon='check'
                                                    size={12}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {taxopark !== 1 && (
                                    <Button
                                        className={styles['choose-txpark-item__button']}
                                        size='small'
                                        variant='secondary'
                                        onClick={() => setTaxopark(1)}
                                    >
                                        Выбрать
                                    </Button>
                                )}
                            </div>
                            <div className={styles['choose-txpark-item']}>
                                <div className={styles['txpark']}>
                                    <div className={styles['txpark__balance']}>
                                        <span className={styles['txpark__balance--integer']}>
                                            4 542
                                        </span>
                                        <span className={styles['txpark__balance--decimal']}>
                                            ,15
                                        </span>
                                        <span className={styles['txpark__balance--currency']}>
                                            {' '}
                                            ₽
                                        </span>
                                    </div>
                                    <div className={styles['txpark__name']}>
                                        <span className={styles['txpark__name--text']}>Драйв</span>
                                        {taxopark === 2 && (
                                            <div className={styles['txpark__name--check']}>
                                                <Icon
                                                    color='var(--extensions-background-deep-brand)'
                                                    icon='check'
                                                    size={12}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {taxopark !== 2 && (
                                    <Button
                                        className={styles['choose-txpark-item__button']}
                                        size='small'
                                        variant='secondary'
                                        onClick={() => setTaxopark(2)}
                                    >
                                        Выбрать
                                    </Button>
                                )}
                            </div>
                        </div>
                    </BottomSheet>
                )}
            </div>
}
